import { createListFilters } from '../../../../../components'

export type SetoresClienteFilters = {
  /** Nome do setor (busca parcial). */
  nome: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<SetoresClienteFilters>({
  nome: '',
})
